<hyperkit-dialog
  class="hyperkit-component"
  [headerText]="options.headerText"
  [primaryButtonText]="options.primaryButtonText"
  [secondaryButtonText]="options.secondaryButtonText"
  (primaryAction)="onSubmit()"
  (secondaryAction)="onClose()"
>
  <hyperkit-typography display="inline" variant="body">
    Are you sure you want to revert this query? This will discard your changes
    and cannot be undone.
  </hyperkit-typography>
</hyperkit-dialog>
